module.exports = __webpack_public_path__ + "media/images/acad_council/john_wong-6c061e6945164fccbf0cc84ff3489a53.jpg";